import React, { FC, useState } from 'react'

import { Txt, DecorationTitle, Card } from 'src/components/atoms'
import { ToggleWithTxt } from 'src/components/molecules'

type Props = {
  className?: string
}

export const AuthenticationMethodSetting: FC<Props> = ({ className }) => {
  const [enabledSaml, setEnabledSaml] = useState(false)
  const [enabledIdPassLogin, setEnabledIdPassLogin] = useState(false)

  return (
    <div className={className}>
      <Card padding="--s1">
        <DecorationTitle>認証方法</DecorationTitle>

        <div>
          <Txt className="tw-text-standardText-secondary tw-mt-s1">
            自社のログイン認証を許可するとアクセス制限がかかり、セキュリティ性の向上が見込まれます。
          </Txt>
          <ToggleWithTxt
            text="SAML"
            enabled={enabledSaml}
            onChange={setEnabledSaml}
            className="tw-mt-s1"
          />
        </div>

        <div className="tw-border-t tw-border-dotted tw-border-bordered tw-border-border-secondary tw-mt-s2">
          <Txt className="tw-text-standardText-secondary tw-mt-s1">
            WORKS用のアカウントの作成を許可します。
          </Txt>
          <ToggleWithTxt
            text="IDとパスワードでログインを許可"
            enabled={enabledIdPassLogin}
            onChange={setEnabledIdPassLogin}
            className="tw-mt-s1"
          />
        </div>
      </Card>
    </div>
  )
}
